import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminPermisosPage } from "@/features/admin-permisos/components/AdminPermisosPage";
import { catalogoPermisosQueryOptions } from "@/features/admin-permisos/hooks/use-permisos-admin";

/** Ruta `/admin/permisos` · gestor del catálogo de permisos (RBAC · P46). */
export const Route = createFileRoute("/_authed-tw/admin/permisos")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(catalogoPermisosQueryOptions),
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminPermisos]}>
      <AdminPermisosPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
